export const DATE_FORMAT_D_M_YYYY = 'l';
export let FILTERS;

(function (FILTERS) {
  FILTERS["AD_ACCOUNTS"] = "adAccounts";
  FILTERS["END_DATE"] = "endDatetime";
  FILTERS["GOAL_TYPE"] = "goalType";
  FILTERS["MILESTONES"] = "milestone";
  FILTERS["PERCENT_PROGRESS"] = "percentProgress";
  FILTERS["STATUS"] = "status";
})(FILTERS || (FILTERS = {}));

export const DEFAULT_FILTER_VALUES = {
  [FILTERS.STATUS]: ['in_progress', 'exceeded', 'achieved', 'missed'],
  [FILTERS.PERCENT_PROGRESS]: {
    minPercentage: 0,
    maxPercentage: 1000
  }
};